import {
  GET_TICKET_LIST,
  GET_BLOCK_LIST,
  GET_GENERAL_CONFIG,
  GET_CHECKOUT_CONFIG,
  GET_KEY_STORAGE,
  GET_BUSINESS_WORK_HOUR,
  GET_SMS_CONTENT,
  GET_POLICIES,
  GET_TAX,
  GET_BOOKING_WORK_HOUR,
  GET_SERVICE_FEE,
  GET_STORE_RATING_DISPLAY,
  GET_TIP,
  SET_COUNTRY_CODE
} from './appTypes'

export default {
  [GET_TICKET_LIST](state , data){
    state.ticketList = data;
  },
  [GET_BLOCK_LIST](state, data){
    state.blockList = data;
  },
  [GET_GENERAL_CONFIG](state, data){
    state.generalConfig = data;
  },
  [GET_CHECKOUT_CONFIG](state, data){
    state.checkoutConfig = data;
  },
  [GET_KEY_STORAGE](state, data){
    state.keyStorage = data;
  },
  [GET_BUSINESS_WORK_HOUR](state, data){
    state.workingHour = data;
  },
  [GET_BOOKING_WORK_HOUR](state, data){
    state.bookingWorkingHour = data;
  },
  [GET_SMS_CONTENT](state, data){
    state.smsContent = data;
  },
  [GET_POLICIES](state, data){
    state.policyData = data;
  },
  [GET_TAX](state, data){
    state.taxSetting = data;
  },
  [GET_TIP](state, data){
    state.tipSetting = data;
  },
  [GET_SERVICE_FEE](state, data) {
    state.serviceFee = data;
  },
  [GET_STORE_RATING_DISPLAY](state, data) {
    state.storeRating = data;
  },
  [SET_COUNTRY_CODE](state, countryCode) {
    state.countryCode = countryCode;
  }
}
